import '@/components/styles/funding/Button_Fund.scss';

const Button_Fund = ({ children, ...props }) => {
  return <button
      {...props}
        className={'Button_Fund '+props.className}
      >{children}
  </button>;
};

export default Button_Fund;
